// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Button, Dialog } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '@advisor-app/store/store';
import {
  selectOpenLinkAccountModal,
  setOpenLinkAccountModal,
} from '@advisor-app/store/slices/broker';
import { BrokersList } from './brokers-list';
import { useTranslation } from 'react-i18next';

export const ModalLinkAccount = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isOpen = useAppSelector(selectOpenLinkAccountModal);

  const handleCloseModal = () => dispatch(setOpenLinkAccountModal(false));

  return (
    <Dialog open={isOpen}>
      <div className="px-8 py-6">
        <header className="flex flex-col place-content-center place-items-center py-6 text-center">
          <h1 className="mb-3 font-poppins text-xl font-semibold text-title-alt">
            {t('accounts.link-broker-account-title', { ns: 'components' })}
          </h1>
          <p className="font-poppins text-subtitle">
            {t('accounts.link-broker-account-description', { ns: 'components' })}
          </p>
        </header>
        <ul>
          <li className="account-item">
            <BrokersList />
          </li>
        </ul>
        <div className="mt-3 flex justify-end">
          <Button
            variant="outlined"
            color="secondary"
            className="!mr-8"
            onClick={handleCloseModal}
          >
            {t('common.close', { ns: 'common' })}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
